<template>
    <CModal :title="title" :color="is_active ? 'danger' : 'success'" :show.sync="deleteModal">
        <p style="font-weight: bold;">¿Estás seguro que deseas {{is_active ? 'dar de baja' : 'reactivar'}} el alumno seleccionado?</p>
        <br>
        El alumno <b>{{name.toUpperCase()}}</b> será {{is_active ? 'dado de baja del' : 'reactivado en el'}} viaje.
        <br /><br />
        Observaciones:
        <CTextarea v-model="observations" style="width: 100%; border-radius: 0.25rem; border-color: rgb(255,255,255);"
          rows="3"
          text="Must be 8-20 words long."
        ></CTextarea>
        <template #header>
          <h5 class="modal-title">{{title}}</h5>
          <CButtonClose @click="deleteModal = false" class="text-white"/>
        </template>
        <template #footer>
          <CButton @click="deleteModal = false" color="secondary">Cancelar</CButton>
          <CButton v-if="is_active" @click="deactive" color="danger">Desactivar</CButton>
          <CButton v-if="!is_active" @click="active" color="danger">Activar</CButton>
        </template>
    </CModal>
</template>

<script>
import store from '../../../store'

export default {
  name: 'DeactiveModal',
  props: {

  },
  data () {
    return {
      deleteModal: false,
      title: "Eliminar Registro",
      id: 0,
      name: 'Registro',
      observations: '',
      is_active: 1
    }
  },
  methods: {
    show (title, id, name, comments, is_active) {
      this.deleteModal = true;
      this.title = title;
      this.id = id;
      this.name = name;
      this.observations = comments;
      this.is_active = is_active;

      this.loaded();
    },
    deactive () {
      this.deleteModal = false;
      this.$emit("deactive", this.id, this.observations);
    },
    active () {
      this.deleteModal = false;
      this.$emit("active", this.id, this.observations);
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>